var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.644,
    height: 181.56,
    viewBox: "0 0 70.644 181.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_21476",
    x: 0,
    y: 0,
    width: 70.644,
    height: 181.56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#293462",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_21476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21476-2",
    "data-name": "Path 21476",
    d: "M40.418,61.954C38.859,21.948,23.011,0,20.41,0h-.186C17.633,0,1.785,21.948.226,61.954s5.3,71.6,9.612,81.152c3.2,7.089,4.419,8.453,7.186,8.453s2.6-1.67,2.6-2.892,0-3.2.692-3.2h.01c.692,0,.692,1.976.692,3.2s-.176,2.892,2.6,2.892,3.975-1.365,7.186-8.453c4.315-9.553,11.171-41.147,9.612-81.152M27.141,121.26H16.487a3.086,3.086,0,0,1-3.1-3.055v-57.2a.037.037,0,0,1,.01-.031,2.553,2.553,0,0,1,3.139-2.332c1.146.234,2.292.489,3.428.794a18.25,18.25,0,0,1,8.342,4.43,6.777,6.777,0,0,1,1.889,4.8c.01,10.063.041,49.539.041,49.539a3.079,3.079,0,0,1-3.1,3.055m3.737-65.784c-1.507-2.943-4.584-4.563-7.547-5.428s-6.06-1.2-8.879-2.587a8.2,8.2,0,0,1-4.77-7.333A9.141,9.141,0,0,1,19.5,36.136c3.758.825,7.093,3.738,9.065,7.374a21.785,21.785,0,0,1,2.313,11.967",
    transform: "translate(20 10)",
    fill: "#fff",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsupIcon);
export default __webpack_public_path__ + "static/media/IsupIcon.4be50b5f3f3550b95d6470ab161cdf17.svg";
export { ForwardRef as ReactComponent };